import { render, staticRenderFns } from "./CustomerDashboardMobile.vue?vue&type=template&id=5acfca2c&scoped=true"
import script from "./CustomerDashboardMobile.vue?vue&type=script&lang=js"
export * from "./CustomerDashboardMobile.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboardMobile.vue?vue&type=style&index=0&id=5acfca2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfca2c",
  null
  
)

export default component.exports